import { AnyFn } from '@direct-frontend/stdlib';

/**
 * Дополняет хук методом `parallel`, для вызова в useParallelQueries.
 * Следует использовать для хуков, которые внутри себя используют сгенерированные query-хуки.
 *
 * @example
 *
 * Создание хука:
 *
 * ```ts
 * const { createQueryHook } from '@direct-frontend/modules-store';
 * const { api as generatedApi } from './generated';
 *
 * const useCampaignsQuery = createQueryHook((options?: { skip: boolean }) => {
 *     const { ulogin } = getDirectContext();
 *
 *     return api.useCampaignsQuery({ variables: { ulogin }}, options)
 * });
 * ```
 * Использование в компоненте:
 *
 * ```
 * useParallelQueries(
 *     useOperatorInfoQuery.parallel(),
 *     useCampaignsQuery.parallel()
 * );
 * ```
 *
 * @param queryHook создаваемый query-хук
 * @returns query-хук с методом для параллельных запросов
 */
export function createQueryHook<QueryHook extends AnyFn>(queryHook: QueryHook) {
    Object.assign(queryHook, {
        parallel(...args: Parameters<QueryHook>) {
            return () => queryHook.apply(queryHook, args);
        },
    });

    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return queryHook as QueryHook & {
        parallel: (...args: Parameters<QueryHook>) => () => ReturnType<QueryHook>;
    };
}
